var irreducible = require('./irreducible');

module.exports = irreducible('Any', function () { return true; });



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/Any.js
 ** module id = 235
 ** module chunks = 0
 **/